import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=0af2615a&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af2615a"]])

export default __exports__